module.exports = function(h, row) {
    if (row.receipt_type === 'Return' || row.receipt_type === 'Void') {
        return <span class="text-danger text-right">{row.total_amount}</span>;
    } else {
        return <span class="text-success text-right">{row.total_amount}</span>;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/transaction/type.jsx